import React from "react";

const MultiplyIcon = ({ className, size = 15, color = "#6E7784", ...props }) => (
  <svg
    width={size}
    height={Math.round((size * 16) / 15)}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M1.5 1.5L7.5 7.5M7.5 7.5L13.5 13.5M7.5 7.5L13.5 1.5M7.5 7.5L1.5 13.5"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export default MultiplyIcon;
